import config from '../../../../config/config';
import { Configuration, ProjectsApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const projApi = new ProjectsApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
